import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/purchase';

export default function Purchase() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
